/** "Oct 1, 2026", in the viewer's time zone. */
export function formatDate(value: string | Date): string {
  return new Date(value).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

/** "Oct 1, 2026, 14:05:09 GMT+2", in the viewer's time zone: the exact time behind a date. */
export function formatDateTime(value: string | Date): string {
  return new Date(value).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
    timeZoneName: 'short',
  })
}
